export enum TransferTableType {
  Pending = 'pending',
  Rejected = 'rejected',
  Scheduled = 'scheduled',
}

export const TRANSFERS_TEXT = {
  pending: {
    tableTitle: 'Pending Transfers',
    toastSuccess: 'Transfer cancelled.',
    toastError: 'Something went wrong and we were unable to cancel this transfer.',
    modalHeader: 'Are you sure you want to cancel this transaction?',
  },

  rejected: {
    tableTitle: 'Cancelled / Rejected Transfers',
    toastSuccess: 'Message was removed.',
    toastError: 'Something went wrong and we were unable to remove this message.',
    modalHeader: 'Are you sure you want to remove this message?',
  },

  scheduled: {
    tableTitle: 'Scheduled Transfers',
    toastSuccess: 'Scheduled transfers cancelled.',
    toastError: 'Something went wrong and we were unable to cancel this scheduled transfer.',
    modalHeader: 'Are you sure you want to cancel this scheduled transfer?',
  },
};

export const CONFIRMATION_MODAL_HEADER_ID = 'confirm-modal--header';
